import React from "react";
import Link from "@qlik/qlik/src/components/Link";
import { createParameterizedUrl } from "@qlik/qlik/src/lib/util/helpers";

const LinkWithDescription = ({ data }) => {
    const { title, description, browsingContext } = data ?? {};

    let pageUrl = createParameterizedUrl(data);
    const linkProps = {
        to: pageUrl,
        newWindow: browsingContext === "New Tab",
        className:
            "z-1 group/link relative flex flex-col gap-1.5 h-full pl-5.5 text-gray xl:text-md xl:tracking-tight4 transition-colors duration-300 before:content-[''] before:absolute before:h-full before:w-0.5 before:left-0 before:t-0 before:bg-stone/50 before:transition-colors before:duration-300 xl:hover:before:bg-green",
    };

    return (
        <div className="h-full">
            <Link {...linkProps}>
                <span className="-z-1 absolute -inset-2.5 rounded bg-white shadow-xlSmall opacity-0 transition-opacity duration-300 xl:group-hover/link:opacity-100" />
                {title && (
                    <p className="font-bold leading-none tracking-normal transition-opacity duration-300 xl:group-hover/link:text-green ">
                        {title}
                    </p>
                )}
                {description && <p className="text-xs xl:text-sm leading-tight tracking-normal">{description}</p>}
            </Link>
        </div>
    );
};
export default LinkWithDescription;
